import React from 'react';

import { Divider } from 'components';
import i18n from 'i18n';
import { t } from 'i18next';
import {
  Bank,
  Card,
  Code,
  DocumentText,
  Home,
  People,
  Personalcard,
  Setting2,
} from 'iconsax-react';

import { OrganizationMenuHeader } from './OrganizationMenuHeader';

import {
  apiSpecUrl,
  appUrl,
  auditUrl,
  bankListUrl,
  memberListUrl,
  payeeListUrl,
  paymentListUrl,
  settingsUrl, // userActivityListUrl,
  userOrganizationPayeeListUrl,
  userOrganizationPaymentListUrl,
} from 'constants/url';

import { APIOrganization, APIUserRight } from 'types/api';
import { MenuType, PlanFeature } from 'types/app';

import { palette } from 'styles/theme';

export const OrganizationUserMenu = (
  organization: APIOrganization,
): MenuType[] => [
  {
    items: [
      {
        component: <OrganizationMenuHeader {...organization} />,
      },
      {
        url: () => appUrl(),
        id: 'menu-home',
        text: i18n.t('menu.home'),
        icon: <Home variant="TwoTone" color={palette.whiteText} size="20" />,
      },
      {
        url: () => userOrganizationPaymentListUrl(organization.id),
        id: 'menu-user-organization-payment',
        text: i18n.t('menu.myPayments'),
        icon: <Card variant="TwoTone" color={palette.whiteText} size="20" />,
      },
      {
        url: () => userOrganizationPayeeListUrl(organization.id),
        id: 'menu-user-organization-payee',
        text: i18n.t('menu.myPayees'),
        icon: (
          <Personalcard variant="TwoTone" color={palette.whiteText} size="20" />
        ),
      },
    ],
  },
];

export const OrganizationAdminMenu = (
  organization: APIOrganization,
): MenuType[] => [
  {
    items: [
      { component: <Divider sx={{ margin: '0.5rem 0' }} /> },
      {
        id: 'menu-organization-bank',
        url: () => bankListUrl(organization.id),
        text: i18n.t('menu.banks'),
        userRight: APIUserRight.BankAccess,
        icon: <Bank variant="TwoTone" color={palette.whiteText} size="20" />,
      },
      {
        id: 'menu-organization-payment',
        url: () => paymentListUrl(organization.id),
        text: i18n.t('menu.allPayments'),
        userRight: APIUserRight.PaymentProcessing,
        icon: <Card variant="TwoTone" color={palette.whiteText} size="20" />,
      },
      {
        id: 'menu-organization-payee',
        url: () => payeeListUrl(organization.id),
        text: i18n.t('menu.allPayees'),
        userRight: APIUserRight.PayeeDirectory,
        icon: (
          <Personalcard variant="TwoTone" color={palette.whiteText} size="20" />
        ),
      },
      {
        id: 'menu-organization-member',
        url: () => memberListUrl(organization.id),
        text: 'Members',
        userRight: APIUserRight.MemberAdministration,
        icon: <People variant="TwoTone" color={palette.whiteText} size="20" />,
      },
      // TODO: Hide until implemented
      // {
      //   url: () => userActivityListUrl(organization.id),
      //   text: 'User activity',
      //   userRight: APIUserRight.ViewUserActivity,
      //   icon: <ManageSearchRoundedIcon color="primary" fontSize="small" />,
      // },
      {
        id: 'menu-organization-audit',
        url: () => auditUrl(organization.id),
        text: t('menu.audit'),
        userRight: APIUserRight.ViewUserActivity,
        icon: (
          <DocumentText variant="TwoTone" color={palette.whiteText} size="20" />
        ),
      },
      {
        id: 'menu-organization-settings',
        url: () => settingsUrl(organization.id),
        text: i18n.t('menu.settings'),
        userRight: APIUserRight.SettingsAccess,
        icon: (
          <Setting2 variant="TwoTone" color={palette.whiteText} size="20" />
        ),
      },
      {
        id: 'menu-organization-api',
        url: () => apiSpecUrl(organization.id),
        text: 'API',
        userRight: APIUserRight.ApiDocumentationAccess,
        planFeature: PlanFeature.ApiAccess,
        icon: <Code variant="TwoTone" color={palette.whiteText} size="20" />,
      },
    ],
  },
];
